//Module Keys
let locales = {};

//Merge Views
import packagesMain from 'Modules/packages/views/main/lan/en';
import featureTab from 'Modules/packages/.components/featureTab/lan/en';
import packageOverview from 'Modules/packages/views/overview/lan/en';
import createEditPackage from 'Modules/packages/.components/createEditPackage/lan/en';
import deletePackage from 'Modules/packages/.components/deletePackage/lan/en';
import assignedToTab from 'Modules/packages/.components/assignedToTab/lan/en';
import packagesTab from 'Modules/packages/.components/tab/lan/en';

locales = { 
    ...locales,
    ...packagesMain,
    ...featureTab,
    ...packageOverview,
    ...createEditPackage,
    ...deletePackage,
    ...assignedToTab,
    ...packagesTab,
};

export default locales;